<script lang="ts">
	let { class: className = "size-6" }: { class?: string } = $props();
</script>

<svg class={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
	<path
		d="M19.321 5.562a5.122 5.122 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.849-1.263-1.78-1.263-2.848V1H13.55v14.822c0 .878-.366 1.663-.952 2.238-.598.587-1.418.952-2.317.952-1.758 0-3.185-1.427-3.185-3.185 0-1.758 1.427-3.185 3.185-3.185.329 0 .646.054.941.154v-2.906a6.072 6.072 0 0 0-.941-.074c-3.39 0-6.133 2.743-6.133 6.133s2.743 6.133 6.133 6.133 6.133-2.743 6.133-6.133V9.756a8.946 8.946 0 0 0 5.204 1.651V8.48a5.888 5.888 0 0 1-2.296-.918Z"
	/>
</svg>
